export default [
	'Apalai',
	'Galibi Kali’nã',
	'Galibi-Marworno',
	'Karipuna',
	'Kaxuyana',
	'Palikur',
	'Tiriyo',
	'Wajãpi',
	'Wayana',
];
